module.exports = __webpack_public_path__ + "static/media/ATLANTIC.6ecccdf8.pdf";